import { animate, style, transition, trigger } from '@angular/animations';

// Fade Animation
export const DIALOG_ANIMATION = trigger('dialog', [
  transition('* => open', [
    style({ opacity: 0, transform: 'translateY(50vh) scale(.7)' }),
    animate('950ms cubic-bezier(0,.74,0,1)', style({ opacity: 1, transform: 'translateY(0) scale(1)' }))
  ]),
  transition('* => close', [
    style({ opacity: 1, transform: 'translateY(0%) scale(1)' }),
    animate('450ms cubic-bezier(.54,.76,.51,1.03)', style({ opacity: 0, transform: 'translateY(10%) scale(.7)' }))
  ])
]);
